module.exports = __webpack_public_path__ + "img/zippo3.86c29ab2.webp";